module.exports = __webpack_public_path__ + "tables/media/Flaticon.96850e10.eot";